import { Button } from '@mui/material'
import { forwardRef } from 'react'
import { TextInputField, TextInputFieldProps } from 'utoniq-ui'

import { formRegex, tLabel, useTranslation } from '@/core'
import { Cell, CellFrame, Organism } from '@/core/architecture'
import { Form, useForm, UseFormProps } from '@/core/form'

export type PasswordResetSendFormProps = {
  onSubmitPasswordResetSend: (
    inputs: PasswordResetSendFormValues
  ) => Promise<void>
}

export type PasswordResetSendFormValues = {
  email: string
}

const schema: UseFormProps['schema'] = o => ({
  email: o
    .string()
    .regex(formRegex.email)
    .label(tLabel('passwordResetSend.email')),
})

/**
 *  PasswordResetSend Form Organism.
 *
 *  This component is organism layer but is named suffix xxForm,
 *  because all of form components belong to Organism.
 */
export const PasswordResetSendForm: Organism<PasswordResetSendFormProps> = ({
  onSubmitPasswordResetSend,
}) => {
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm<PasswordResetSendFormValues>({
    schema,
  })

  return (
    <Form onSubmit={handleSubmit(onSubmitPasswordResetSend)}>
      <TextInputCell
        type="email"
        error={errors?.email}
        {...register('email')}
      />

      <ButtonCell loading={isSubmitting} />
    </Form>
  )
}

const TextInputCell = forwardRef(
  (props: Omit<TextInputFieldProps, 't'>, ref) => {
    const { t } = useTranslation('passwordResetSend')

    return (
      <CellFrame>
        <TextInputField {...props} ref={ref} t={t} />
      </CellFrame>
    )
  }
)

type ButtonCellProps = {
  loading: boolean
}
const ButtonCell: Cell<ButtonCellProps> = ({ loading }) => {
  const { t } = useTranslation('passwordResetSend')

  return (
    <CellFrame sx={{ py: 2, textAlign: 'center' }}>
      <Button type="submit" size="large" sx={{ width: 244 }} loading={loading}>
        {t('submit')}
      </Button>
    </CellFrame>
  )
}
